<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Alert from "../stores/alerts";

    const FORM_STEP = {
        SEARCH_ACCOUNT: 1,
        SELECT_ACCOUNT: 2,
        NOT_FOUND: 3,
    }

    export let callbackFunction;

    let step = FORM_STEP.SEARCH_ACCOUNT;
    let afm = '';
    let account = null;
    let error = null;
    let accountExist = false;

    /* Step 1 */
    const searchAccount = () => {
        const onSuccess = result => {
            if (result) {
                account = result;
                step = FORM_STEP.SELECT_ACCOUNT;
            } else {
                step = FORM_STEP.NOT_FOUND;
            }
        }

        const onFailure = err => {
            if (err.code && err.code === 'account_activated') {
                error = "Υπάρχει ήδη ένας λογαριασμός σε χρήση με το ΑΦΜ που πληκτρολογήσατε.";
                accountExist = true;
            } else {
                error = err.message;
            }
        };

        error = null;
        accountExist = false;
        afm = afm.trim();
        if (afm.length < 9) {
            error = "To ΑΦΜ που πληκτρολογήσατε δεν είναι έγκυρο!";
            setFocusTo('vetAFM');
            return;
        }

        R.handle(R.account.search, {afm}, onSuccess, onFailure, LOADER.POPUP);
    }


    const onAcceptAccount = () => {

        const onSuccess = result => {
            callbackFunction({action:'confirm', id:account.id, email: result});
        }

        const onFailure = err => {
            if (err.code) {
                Alert.warning(err.message);
            }
        };

        R.handle(R.account.getEmail, account.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onDeclineAccount = () => {
        step = FORM_STEP.NOT_FOUND;
    }

    const onCreateAccount = () => {
        callbackFunction({action:'create', afm});
    }

</script>
{#if step == FORM_STEP.SEARCH_ACCOUNT}
    <!-- Search account by AFM -->
    <form on:submit|preventDefault|stopPropagation="{ searchAccount }">
        <div class="row">
            <div class="col-xl-4">
                <div class="form-group">
                    <p>Πληκτρολογήστε το ΑΦΜ σας</p>
                    <input type="text" class="form-control" id="vetAFM" bind:value="{ afm }"
                           on:keyup={ () => { error = null; accountExist = false; }}
                           placeholder="ΑΦΜ" required>
                </div>
                {#if error}
                    <div class="alert alert-danger">{@html error }</div>
                {/if}
                <button class="btn btn-primary btn-block" disabled="{ accountExist }">Επόμενο <i
                        class="fa fa-chevron-right"></i></button>
            </div>
        </div>
    </form>
{:else if step == FORM_STEP.SELECT_ACCOUNT}
    <!-- Display Account Data -->
    <div class="row">
        <div class="col-xl-6">
            <p class="mb-5">Βρέθηκε εγγραφή στα μητρώα του συλλόγου με τα παρακάτω στοιχεία.</p>
            <h4 class="mb-3">{ account.lastname } { account.firstname }</h4>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <h6 class="mb-1">Αρ. Μητρώου</h6>
                    <div class="form-control-data mb-4">{ account.code }</div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <h6 class="mb-1">ΑΦΜ</h6>
                    <div class="form-control-data mb-4">{ account.afm }</div>
                </div>
            </div>
            <div class="row">
                {#if account.phone1}
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <h6 class="mb-1">Τηλέφωνο 1</h6>
                        <div class="form-control-data mb-4">{ account.phone1 }</div>
                    </div>
                {/if}
                {#if account.phone2}
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <h6 class="mb-1">Τηλέφωνο 2</h6>
                        <div class="form-control-data mb-4">{ account.phone2 }</div>
                    </div>
                {/if}
            </div>
            <div class="row">
                {#if account.mobile}
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <h6 class="mb-1">Κινητό</h6>
                        <div class="form-control-data mb-4">{ account.mobile }</div>
                    </div>
                {/if}
                {#if account.email}
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <h6 class="mb-1">Email</h6>
                        <div class="form-control-data mb-4">{ account.email }</div>
                    </div>
                {/if}
            </div>
            <div class="row">
                {#if account.city}
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <h6 class="mb-1">Πόλη</h6>
                        <div class="form-control-data mb-4">{ account.city }</div>
                    </div>
                {/if}
                {#if account.region}
                    <div class="col-xl-6 col-lg-6 col-md-6">
                        <h6 class="mb-1">Νομός</h6>
                        <div class="form-control-data mb-4">{ account.region.name }</div>
                    </div>
                {/if}
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <button class="btn btn-danger btn-block" on:click={ onDeclineAccount }>
                        <i class="fa fa-remove"></i> Δεν είναι τα στοιχεία μου!
                    </button>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <button class="btn btn-primary btn-block" on:click={ onAcceptAccount }>
                        <i class="fa fa-check"></i> Αυτά είναι τα στοιχεία μου
                    </button>
                </div>
            </div>

        </div>
    </div>
{:else if step == FORM_STEP.NOT_FOUND}
    <!-- Not found -->
    <div class="row">
        <div class="col-xl-6">
            <p>Φαίνεται πως δεν υπάρχει εγγραφή στα μητρώα του συλλόγου με τα στοιχεία σας.</p>
            <p class="mb-5">Θέλετε να δημιουργήσετε έναν λογαριασμό στον Π.Κ.Σ.;</p>
            <p class="text-center">
                <button class="btn btn-primary" on:click="{ onCreateAccount }">Δημιουργία λογαριασμού</button>
            </p>
        </div>
    </div>
{/if}